// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-app-container > .container {\n  width: 100% !important;\n  max-width: 1152px !important;\n}\n@media screen and (max-width: 768px) {\nwc-econt-nav {\n    right: 0 !important;\n}\n.vue-app-container > .container {\n    max-width: none !important;\n}\n}", ""]);
// Exports
module.exports = exports;
